export const SET_REQUEST_VERIFICATION_LOADING = 'setRequestVerficationLoading'
export const SET_CHECK_VERIFICATION_LOADING = 'setCheckVerficationLoading'
export const SET_USER_REGISTRATION_LOADING = 'setUserRegistrationLoading'
export const SET_RESET_PASSWORD_LOADING = 'setResetPasswrodLoading'
export const SET_USER = 'setUser'
export const SET_PHONE_VERIFIED = 'setPhoneVerified'
export const SET_REQUEST_PHONE_NUMBER = 'setRequestPhoneNumber'
export const REQUEST_PHONE_NUMBER_FAILURE = 'requestPhoneNumberFailure'
export const REQUEST_PHONE_NUMBER_SUCCESS = 'requestPhoneNumberSuccess'
export const CHECK_PHONE_NUMBER_FAILURE = 'checkPhoneNumberFailure'
export const CHECK_PHONE_NUMBER_SUCCESS = 'checkPhoneNumberSuccess'
export const REGISTER_FAILURE = 'registerFailure'
export const REGISTER_SUCCESS = 'registerSuccess'
export const SEND_RESET_PASSWORD_EMAIL_SUCCESS = 'sendResetPasswordEmailSuccess'
export const SEND_RESET_PASSWORD_EMAIL_FAILURE = 'sendResetPasswordEmailFailure'
